<template>
  <v-container grid-list-md>
    <v-expansion-panel v-model="panel" expand style="margin: 10px 0px">
      <v-expansion-panel-content>
        <template v-slot:header>
          <div class="title">表示条件</div>
        </template>
        <v-card>
          <v-card-text>
            <v-layout align-center justify-start row fill-height>
              <v-flex md2 class="search-label subheading">年月</v-flex>
              <v-flex md2>
                <v-select :items="years" v-model="year" suffix="年" />
              </v-flex>
              <v-flex md1>
                <v-select :items="months" v-model="month" suffix="月" />
              </v-flex>
            </v-layout>
            <v-layout align-center justify-start row fill-height>
              <v-flex md2 class="search-label subheading">スタッフ</v-flex>
              <v-flex md8>
                <v-autocomplete
                  v-model="selectedStaffs"
                  :items="staffs"
                  chips
                  item-text="name"
                  item-value="name"
                  multiple
                  :menu-props="{ auto: true, overflowY: true }"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex md2>
                <v-btn @click="clearSelectedStaffs">
                  <v-icon>backspace</v-icon>クリア
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout align-center justify-start row fill-height>
              <v-flex md2 class="search-label subheading">チーム</v-flex>
              <v-flex md2 v-for="(team, i) in teams" :key="i">
                <v-checkbox
                  v-model="selectedTeams"
                  :label="team"
                  :value="team"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout align-center justify-start row fill-height>
              <v-flex md2 class="search-label subheading">フリーワード *</v-flex>
              <v-flex md4>
                <v-text-field v-model="search"></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-btn color="green" class="white--text" @click="downloadUsersFile">
      <v-icon color="white">cloud_download</v-icon>ダウンロード
    </v-btn>
    <v-layout style="height: 500px; width: 100%">
      <div class="table-container scroll-bar">
        <v-data-table
          :headers="headers"
          :items="filteredItems"
          class="elevation-1"
          :search="search"
          :pagination.sync="pagination"
          rows-per-page-text="表示行"
          :rows-per-page-items="rowsPerPageItems"
          style="width: 1500px"
        >
          <template v-slot:headers="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="{ sticky: true, 'column-fixed': header.text == '日' }"
              >
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <tr @click="toTimesheet(props.item)">
              <td class="text-xs-left">{{ props.item.staffNo }}</td>
              <td class="text-xs-left">{{ props.item.staffName }}</td>
              <td class="text-xs-left">{{ props.item.workType }}</td>
              <td>{{ props.item.clientId }}</td>
              <td>{{ props.item.clientName }}</td>
              <td>{{ props.item.time }}</td>
              <td>{{ props.item.salary }}</td>
              <td>{{ props.item.commuting_allowance }}</td>
              <td>{{ props.item.insurance }}</td>
              <td>{{ props.item.totalTime }}</td>
              <td>{{ props.item.subtotalSalary }}</td>
              <td>{{ props.item.subtotalCommuting }}</td>
              <td>{{ props.item.subtotalInsurance }}</td>
            </tr>
          </template>
          <template slot="pageText" slot-scope="props"
            >{{ props.itemsLength }} 件中 {{ props.pageStart }} -
            {{ props.pageStop }} 件表示</template
          >
        </v-data-table>
      </div>
    </v-layout>
    <v-btn color="green" class="white--text" @click="scrollToTop">
      <v-icon color="white">arrow_upward</v-icon>トップへ戻る
    </v-btn>
  </v-container>
</template>

<script>
import db from "@/components/firebaseInit";
import ReadTimecard from "@/components/ManageAttendance/readTimecard.vue";
import { mapGetters, mapState, mapActions } from "vuex";
import { getMoment, unixtimeToFormattedLargeTime } from "@/utils/datetime.js";
import XLSX from "xlsx";
import { teamsArray } from "@/master/users.js";

export default {
  components: {
    ReadTimecard,
  },
  data() {
    return {
      dbRef: db.collection("timesheets"),
      dialog: false,
      year: 2020,
      month: 1,
      dates: [],
      timecards: [],
      items: [],
      years: [2019, 2020, 2021, 2022, 2023, 2023, 2024, 2025, 2026, 2027],
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      teams: teamsArray,
      selectedTeams: [],
      selectedTimecard: {},
      panel:[true],
      selectedStaffs: [],
      staffs: [],
      headers: [
        { text: "社員番号​ *", value: "staffNo", sortable: true },
        { text: "名前​ *", value: "staffName", sortable: false },
        { text: "勤務種別​ *", value: "workType", sortable: false },
        { text: "クライアントNo *", value: "clientId", sortable: false },
        { text: "クライアント名 *", value: "clientName", sortable: false },
        { text: "時間​", value: "time", sortable: false },
        { text: "給与​", value: "salary", sortable: false },
        { text: "通勤交通費", value: "commuting_allowance", sortable: false },
        { text: "法定福利費", value: "insurance", sortable: false },
        { text: "時間合計​", value: "totalTime", sortable: false },
        { text: "給与小計​", value: "subtotalSalary", sortable: false },
        { text: "通勤交通費小計​", value: "subtotalCommuting", sortable: false },
        { text: "法定福利費小計​", value: "subtotalInsurance", sortable: false },
        {
          text: "通勤交通費小計​",
          value: "subtotalCommuting",
          sortable: false,
        },
        {
          text: "法定福利費小計​",
          value: "subtotalInsurance",
          sortable: false,
        },
      ],
      pagination: {
        rowsPerPage: 200,
      },
      rowsPerPageItems: [100, 200, 500],
      search: "",
      tableItems: [],
    };
  },
  created() {
    const today = getMoment()();
    this.month = today.month() + 1;
    this.year = today.year();
  },
  mounted() {
    this.reloadStaffs();
    this.fixHeaders();
  },
  computed: {
    month_id() {
      return String(this.year) + "-" + ("0" + this.month).slice(-2);
    },
    filteredItems() {
      return this.tableItems.filter((item) => {
        return (
          this.selectedTeams.includes(item.team) &&
          (this.selectedStaffs.length == 0 ||
            this.selectedStaffs.includes(item.staffName))
        );
      }, this);
    },
    ...mapGetters("auth", ["CanI", "isLoggedIn", "user", "profile"]),
    ...mapState("auth", ["authorities"]),
  },
  watch: {
    month() {
      this.reloadItems();
    },
  },
  methods: {
    clearSelectedStaffs() {
      this.selectedStaffs = [];
    },
    async reloadStaffs() {
      this.changeLoadingState(true);
      this.staffs = [];
      try {
        const staffs = await db.collection("users").get();
        staffs.forEach((doc) => {
          this.staffs.push({ ...doc.data(), id: doc.id });
        });
      } finally {
        this.changeLoadingState(false);
      }
    },
    scrollToTop() {
      document.querySelector(".v-datatable tbody tr").scrollIntoView(false);
    },
    fixHeaders() {
      var elms = document.getElementsByClassName("v-table__overflow");
      elms[0].style.overflow = "visible";
    },
    async reloadItems() {
      this.changeLoadingState(true);
      this.tableItems = [];
      const items = await this.dbRef
        .where("month_id", "==", this.month_id)
        .where("version", ">=", 2)
        .get();
      this.items = [];
      items.forEach((doc) => {
        const item = doc.data();
        if (item.status != "入力中") {
          const staffNo = item.staff_id;
          const staffName = item.user_name;
          const team = item.team_name;
          const workType = item.work_type;
          const costTotal = item.counts.cost.total ? item.counts.cost.total : 0;
          const subtotalSalary = item.counts.money.subtotalSalary;
          const commuting_allowance = item.counts.money.commuting_allowance;
          const subtotalInsurance = item.counts.money.subtotalInsurance;
          Object.keys(item.counts.cost).forEach((clientId) => {
            const cost = item.counts.cost[clientId];
            if (cost.time > 0) {
              this.addToTableItems(
                staffNo,
                staffName,
                workType,
                cost,
                costTotal,
                subtotalSalary,
                commuting_allowance,
                subtotalInsurance,
                team
              );
            }
          });
        }
      });
      // this.tableItems = this.tableItems.sort(function(a, b) {
      //   return Number(a.staffNo) - Number(b.staffNo);
      // });
      this.changeLoadingState(false);
    },
    addToTableItems(
      staffNo,
      staffName,
      workType,
      cost,
      costTotal,
      subtotalSalary,
      commuting_allowance,
      subtotalInsurance,
      team
    ) {
      const tableItem = {};
      tableItem.staffNo = staffNo;
      tableItem.staffName = staffName;
      tableItem.team = team;
      tableItem.workType = workType;
      tableItem.clientId = cost.client_id;
      tableItem.clientName = cost.client_name;
      tableItem.time = unixtimeToFormattedLargeTime(cost.time);
      tableItem.totalTime = unixtimeToFormattedLargeTime(costTotal);
      if (costTotal > 0) {
        tableItem.salary = Math.round((subtotalSalary * cost.time) / costTotal);
        tableItem.commuting_allowance = Math.round(
          (commuting_allowance * cost.time) / costTotal
        );
        tableItem.insurance = Math.round(
          (subtotalInsurance * cost.time) / costTotal
        );
      }
      tableItem.subtotalSalary = subtotalSalary;
      tableItem.subtotalInsurance = subtotalInsurance;
      tableItem.subtotalCommuting = commuting_allowance;

      this.tableItems.push(tableItem);
    },
    prvMonth() {
      this.month = this.month - 1;
    },
    nextMonth() {
      this.month = this.month + 1;
    },
    getTime(unixtime) {
      return unixtimeToFormattedLargeTime(unixtime);
    },
    toTimesheet(item) {
      const route = this.$router.resolve({
        name: "home",
        params: { user_id: item.userId },
        query: { year: this.year, month: this.month },
      });
      window.open(route.href, "_blank");
    },
    downloadUsersFile() {
      var FileSaver = require("file-saver");
      var workbook = { SheetNames: [], Sheets: {} };
      var wopts = { bookType: "xlsx", bookSST: false, type: "array" };
      const header = [];
      const keys = [];
      const tableData = [];
      this.headers.forEach((h) => {
        header.push(h.text);
        keys.push(h.value);
      });
      tableData.push(header);
      this.tableItems.forEach((item) => {
        const row = [];
        keys.forEach((k) => {
          row.push(item[k]);
        });
        tableData.push(row);
      });
      XLSX.utils.book_append_sheet(
        workbook,
        XLSX.utils.aoa_to_sheet(tableData),
        "CostTable"
      );

      var wbout = XLSX.write(workbook, wopts);
      var blob = new Blob([wbout], { type: "application/octet-stream" });
      FileSaver.saveAs(blob, "CostTable.xlsx");
    },
    ...mapActions("app", ["changeLoadingState"]),
  },
};
</script>

<style lang="css" scoped>
div.pageTitle {
  font-size: 20px;
  color: #ff5722;
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
  margin: 10px;
}
div.yearMonth {
  display: inline-block;
  font-size: 20px;
  /* color: #ddd; */
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
  margin: 10px;
}
td.holiday {
  color: #f44336;
}
td.saturday {
  color: #2196f3;
}
td.text-smaller {
  font-size: 0.8em;
}
.v-datatable th.sticky {
  background-color: white !important;
  position: -webkit-sticky;
  position: sticky;
  z-index: 1;
  top: 0;
}
.scroll-bar {
  overflow: auto;
}
.scroll-bar::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.scroll-bar::-webkit-scrollbar-thumb {
  background: gray;
}
.v-icon {
  margin-right: 0.3em;
}
</style>